import React from 'react';
import AppContent from 'js/components/AppContent';
import Button, { buttonHeight } from 'js/components/common/Button';
import ErrorDisplay from 'js/components/common/ErrorDisplay';
import Constraint from 'js/components/Constraint';
import Backdrop from 'js/components/core/Backdrop';
import Modal from 'js/components/core/Modal';
import SubTitle from 'js/components/core/SteppedPage/SubTitle';
import Title from 'js/components/core/SteppedPage/Title';
import IPAddressesMatchNotification from "js/components/pages/ManageOrderPage/IPAddressesMatchNotification";
import PageComponent from 'js/components/pages/PageComponent';
import { lightGrey1Color } from 'js/config/style';
import { url } from 'js/services/Network';
import AppState from 'js/stores/AppState';
import ManageOrderPageState from 'js/stores/pages/ManageOrderPageState';
import { observer } from 'mobx-react';
import ContactInfo from './ContactInfo';
import Payment from './Payment';
import Summary from './Summary';

@observer
export default class ManageOrderPage extends PageComponent {
  pageName = 'ManageOrderPage';
  pageColor = lightGrey1Color;
  loginRequired = true;
  page = ManageOrderPageState.create({
    uid: this.props.uid,
  });

  backNav = () =>
    AppState.previousPage === 'UserDashboardPage'
      ? {
        mode: 'back',
        text: 'Dashboard',
        url: url('user-dashboard-page'),
      }
      : {
        mode: 'back',
        text: this.page.order_summary.title,
        url: url('status-page', this.page.order_summary),
      };

  bootstrap = () => this.page.load();

  renderPage() {
    const page = this.page;
    const offset = page.isDisabled ? '0rem' : `${buttonHeight / 2}rem`;

    return (
      <AppContent padded>
        <Backdrop offset={offset}>
          <Constraint>
            <Title>Purchase offer</Title>
            {!page.isDisabled && <SubTitle>Click the button to accept the offer and print the shipping label.</SubTitle>}
            <Summary />
          </Constraint>
        </Backdrop>

        {!page.isDisabled && (
          <Constraint offset={offset}>
            <Button disabled={!page.canSubmit} onClick={page.submit} isLoading={page.isSubmitting}>
              Accept offer and ship
            </Button>
            <ErrorDisplay>{page.error}</ErrorDisplay>
          </Constraint>
        )}

        <Modal showModal={page.ipAddressesMatchModalIsVisible} onCancel={page.closeModal} withCloseButton>
          <IPAddressesMatchNotification onSubmit={page.closeIpAddressesMatchModal} />
        </Modal>

        <Modal showModal={page.modalIsVisible} onCancel={page.closeModal} withCloseButton>
          <Payment />
        </Modal>

        <Modal showModal={page.contactModalIsVisible} onCancel={page.closeModal} withCloseButton>
          <ContactInfo onSubmit={page.setContactData} />
        </Modal>
      </AppContent>
    );
  }
}
